module.exports = __webpack_public_path__ + "assets/shadow-staking.a7f75f85.svg";